import {
	AccessibilityType,
	Destination,
	Experience,
	Facility,
	InsideOutside,
	Meal,
	OffersType,
	OvernightStay,
	Period,
	ProductType,
	RoomType,
	TargetAudience,
	Transportation,
} from '@toevla-webapplications/core';
import { Location } from '../../services/locations/location.model';
import { Offer } from '../../services/offers/offer.model';
import { ThemeType } from '../../services/offers/theme-type.enum';
import { User } from '../../services/user/user.model';

export interface OffersStore {
	data: OffersData;
	filters: OffersFilters;
	locations: Location[];
	map: OffersMap;
	maxPriceAccommodation: number;
	maxPriceDaytrip: number;
	order: OffersOrder;
	type: OffersType;
	user: User | null;
}

export interface OffersData {
	list: Offer[];
	loading: boolean;
	nextAvailable: boolean;
	page: number;
	size: number;
	total: number;
	view: 'list' | 'map';
}

export interface OffersFilters {
	destinations: Destination[];
	exclusive: AccessibilityType[];
	experiences: Experience[];
	facilities: Facility[];
	impairments: AccessibilityType[];
	inclusive: AccessibilityType[];
	insideOutside: InsideOutside[];
	location: Location | null;
	meals: Meal[];
	overnightStays: OvernightStay[];
	periods: Period[];
	productTypes: ProductType[];
	roomtypes: RoomType[];
	targetAudiences: TargetAudience[];
	themes: ThemeType[];
	transportations: Transportation[];
	minPrice: number;
	maxPrice: number;
}

export interface OffersMap {
	lat: number;
	long: number;
	zoom: number;
}

export interface OffersOrder {
	name: string;
	asc: boolean;
	sort: string;
}

export const OFFERS_INITIAL_STATE: OffersStore = {
	data: {
		list: [],
		loading: false,
		nextAvailable: true,
		page: 0,
		size: 12,
		total: 0,
		view: 'list',
	},
	filters: {
		destinations: [],
		exclusive: [],
		experiences: [],
		facilities: [],
		impairments: [],
		inclusive: [],
		insideOutside: [],
		location: null,
		meals: [],
		overnightStays: [],
		periods: [],
		productTypes: [],
		roomtypes: [],
		targetAudiences: [],
		themes: [],
		transportations: [],
		minPrice: 0,
		maxPrice: 999,
	},
	locations: [],
	map: {
		lat: 50.845539,
		long: 4.35571,
		zoom: 10,
	},
	maxPriceAccommodation: 999,
	maxPriceDaytrip: 999,
	order: {
		name: 'PRICE_ASC',
		asc: true,
		sort: 'price',
	},
	type: OffersType.DAYTRIP,
	user: null,
};
